import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';


class Kategori extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      url: { url_get_data : '/kategori', url_save_data: '/kategori', url_update_data: '/kategori',
             url_delete_data: '/kategori', url_get_data_per: '/kategori' },
      title: 'Master Kategori',
      title_add : 'Add Data Master Kategori', 
      fields: data_field.data, 
      columns: [ 
        { header: 'Nama', id: 'nama', accessor: 'nama', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Nama Keterangan', id: 'nama_keterangan', accessor: 'nama_keterangan', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Keterangan', id: 'keterangan', accessor: 'keterangan', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Max Upload', id: 'max_download', accessor: 'max_download', child_accessor: null,
            Cell: row => {
                return `${row.value} Mbps`;
                }
        },
        { header: 'Max Upload', id: 'max_upload', accessor: 'max_upload', child_accessor: null,
            Cell: row => {
                return `${row.value} Mbps`;
                }
        },
        { header: 'Klasifikasi', id: 'id', accessor: 'id', child_accessor: null,
            Cell: row => {
              return <button className="btn btn-xs pd-x-10 btn-outline-dark" 
                        onClick={() => this.props.history.push(`/master/kategori/${row.value}/klasifikasi`)}><i className="fa fa-list"></i>
                    </button>
            }
        },
    ],
    }
  }

  render() {
    return (
      <React.Fragment>
          <SidebarDataMaster location={this.props.location.pathname}/>
          <StandardCRUD 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={this.state.fields} 
                id_pk={null} 
                add_form={true}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
          />
          <SectionDataView />
      </React.Fragment>
      
    );
  }
}

export default Kategori;
